import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { validateEntityForm, setEntityDetails } from './helper'
import EntityCreatedData from './EntityFormTable/index';
import {
    Col, Row, Button,
    Form, FormGroup, Label,
} from 'reactstrap';
import { ENTITY_FORM_INITIAL_VALUES } from '../constants'
class EntityDetailsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMsg: '',
            entityFormData: {},
            entityDataFlag: false,
            tableData: null
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.entityFormDetails !== prevProps.entityFormDetails) {
            this.setState({
                entityFormData: this.props.entityFormDetails.values
            })
        }
        if (this.props.entityDetails !== prevProps.entityDetails) {
            if (Object.keys(this.props.entityDetails).length > 0) {
                this.setState({
                    tableData: <EntityCreatedData entityFormData={this.props.entityDetails} entityCreatedDataCallback={this.handleEditEntity} />,
                    entityDataFlag: true
                })
            } else {
                this.setState({
                    tableData: null,
                    entityDataFlag: false
                })
            }
        }
    }
    saveEntityDetails = (event) => {
        event.preventDefault();
        const validateForm = validateEntityForm(this.props.entityFormDetails.values)
        if (validateForm) {
            this.setState({
                entityDataFlag: true,
                tableData: <EntityCreatedData entityFormData={this.state.entityFormData} entityCreatedDataCallback={this.handleEditEntity} />
            })
            this.props.initialize(ENTITY_FORM_INITIAL_VALUES);
            const tempEntityFormData = setEntityDetails(this.props.entityFormDetails.values, this.props.correspondentId)
            this.props.entityFormCallback(tempEntityFormData, validateForm)
        } else {
            this.props.entityFormCallback([], validateForm)
            this.setState({
                tableData: null
            })
        }
    }
    handleEditEntity = (entityData) => {
        this.setState({
            entityFormData: {},
            tableData: null,
            entityDataFlag: false
        })
        this.props.initialize(entityData)
    }
    render() {
        return (
            <div>
                {this.state.tableData}
                {(!this.state.entityDataFlag) ? <Form>
                    <fieldset>
                        <FormGroup className="mb-4">
                            <Label for="company-name">Company Name<span className="text-danger">*</span></Label>
                            <Field name="correspondentEntityName" component="input" type="text" placeholder="Company Name" className='mb3 form-control' />
                        </FormGroup>
                        <FormGroup className="mb-4">
                            <Label for="company-address">Company Address<span className="text-danger">*</span></Label>
                            <Field name="address" component="input" type="text" placeholder="Plot No. / Complex / Street ..." className='mb-3 form-control' />
                            <Row className="mb-3">
                                <Col>
                                    <Field name="city" component="input" type="text" placeholder="City" className='mb-3 form-control' />
                                </Col>
                                <Col className="pl-0">
                                    <Field id="state" name="state" component="select" className='mb3 form-control'>
                                        <option>Select state</option>
                                        {
                                            this.props.stateList.map(state => {
                                                return (
                                                    <option key={state} value={state}>{state}</option>
                                                )
                                            })
                                        }
                                        {/* {fullStatesList} */}
                                    </Field>

                                </Col>
                            </Row>
                            <Field name="pinCode" component="input" type="text" placeholder="Zip code" className='mb3 form-control' />
                        </FormGroup>
                        <FormGroup className="mb-4">
                            <Label for="gst">GST Number<span className="text-danger">*</span></Label>
                            <Field name="gstNum" component="input" type="text" placeholder="22-AAAA0000A-1Z5" id="gst" className='mb-3 form-control' />
                        </FormGroup>
                        <FormGroup className="mb-4">
                            <Label for="pan">PAN Number<span className="text-danger">*</span></Label>
                            <Field name="panNo" component="input" type="text" placeholder="AAAPL1234C" id="pan" className='mb-3 form-control' />
                        </FormGroup>
                        {/* <FormGroup className="mb-4">
                            <Label for="tan">TAN Number</Label>
                            <Field name="tanNum" component="input" type="text" placeholder="NGPO02911A" id="tan" className='mb-3 form-control' />
                        </FormGroup> */}
                        <FormGroup>
                            <Button type="submit" className="d-block ml-auto" color="primary" onClick={this.saveEntityDetails}>Save</Button>
                        </FormGroup>
                        <div className='error'>{this.state.errorMsg}</div>
                    </fieldset>
                </Form> : <div></div>}

            </div>
        )
    }
}

EntityDetailsForm = reduxForm({
    form: 'correspondentEntityForm',
    enableReinitialize: true
})(EntityDetailsForm)



const mapStateToProps = (state, ownProps) => ({
    entityFormDetails: state.form.correspondentEntityForm
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default EntityDetailsForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(EntityDetailsForm)